var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIq = function SvgIq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 0C6.84 0 2.442 3.255.746 7.824h22.507C21.558 3.255 17.16 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 24c5.16 0 9.558-3.256 11.253-7.826H.746C2.442 20.744 6.84 24.001 12 24.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M9.13 11.219H6.817c.116-.45.524-.783 1.01-.783V8.87a2.612 2.612 0 0 0-2.61 2.608v1.305h3.914c.143 0 .26.117.26.26v.522H4.174v1.566h6.782v-2.087c0-1.007-.819-1.826-1.826-1.826ZM13.044 13.566V8.87h-1.566v6.26h2.61v-1.564h-1.044ZM18.26 13.566V8.87h-1.565v4.696h-.521V12h-1.566v3.13h4.696v-1.564h-1.043Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIq;